import React from "react";
import popular from "./popular.png";

const Popular = () => {
  return (
    <div className=" text-center py-5">
      <button className="btn notero-button">One-Time Payment</button>
      <h1 className="py-3 fw-bolder">
        Integration With <span className="text-color">Popular Apps</span>
      </h1>
      <p>
        Amar Net Bill integrate with popular apps. Help you easy to connect and
        collaboration
      </p>
      <div>
        <img className="img-fluid" src={popular} alt="" />
      </div>
    </div>
  );
};

export default Popular;
